import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable()
export class JWTTokenService {

    private jwtTokens: {[key: string]: string} = {};
    private jwtHelper = new JwtHelperService();

    constructor() { }

    setToken(key: string, token: string) {
      if (token) {
        this.jwtTokens[key] = token;
      }
    }

    clearToken(key: string) {
      this.jwtTokens[key] = null;
    }

    getToken(key: string) {
        return this.jwtTokens[key];
    }
 
    decodeToken(key: string) {
      if (this.jwtTokens[key]) {
        return this.jwtHelper.decodeToken(this.jwtTokens[key]);
      }
      return null;
    }

    isTokenExpired(key: string): boolean {
      if (this.jwtTokens[key]) { 
        return this.jwtHelper.isTokenExpired(this.jwtTokens[key]);
      };
      return true;     
    }
}

export interface JwtClaims { 
  actort: string;
  nameid: string;
  role: string[];
  vendorId: string;
}


